/**
 * Geneo AI · Public Changelog
 *
 * Only the last 3 shipped upgrades — keep this tight; users don't need a wall of text.
 * Update this list as new upgrades land.
 */
export const CHANGELOG = [
  {
    id: "feedback-chip",
    date: "Feb 2026",
    title: "Beta Feedback Chip",
    body: "Floating chip on every page — send us bugs, ideas, or praise in one line.",
    tag: "New",
  },
  {
    id: "timeline-pro",
    date: "Feb 2026",
    title: "Timeline Editor Pro",
    body: "Split, speed (0.25x-2x), frame stepping, capture-to-pipeline, undo/redo, zoom, and clip volume.",
    tag: "Upgrade",
  },
  {
    id: "storyboard-v2",
    date: "Feb 2026",
    title: "Storyboard Node Canvas v2",
    body: "Drag-to-reorder nodes, per-scene titles, image uploads, and Omni references on every card.",
    tag: "Upgrade",
  },
];
